function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontfamily/fontfamilyui
 */
import { Plugin } from 'ckeditor5/src/core';
import { Collection } from 'ckeditor5/src/utils';
import { Model, createDropdown, addListToDropdown } from 'ckeditor5/src/ui';
import { normalizeOptions } from './utils';
import { FONT_FAMILY } from '../utils';
import fontFamilyIcon from '../../theme/icons/font-family.svg';
/**
 * The font family UI plugin. It introduces the `'fontFamily'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */

var FontFamilyUI =
/*#__PURE__*/
function (_Plugin) {
  _inherits(FontFamilyUI, _Plugin);

  function FontFamilyUI() {
    _classCallCheck(this, FontFamilyUI);

    return _possibleConstructorReturn(this, _getPrototypeOf(FontFamilyUI).apply(this, arguments));
  }

  _createClass(FontFamilyUI, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var t = editor.t;

      var options = this._getLocalizedOptions();

      var command = editor.commands.get(FONT_FAMILY); // Register UI component.

      editor.ui.componentFactory.add(FONT_FAMILY, function (locale) {
        var dropdownView = createDropdown(locale);
        addListToDropdown(dropdownView, _prepareListOptions(options, command));
        dropdownView.buttonView.set({
          label: t('Font Family'),
          icon: fontFamilyIcon,
          tooltip: true
        });
        dropdownView.extendTemplate({
          attributes: {
            "class": 'ck-font-family-dropdown'
          }
        });
        dropdownView.bind('isEnabled').to(command); // Execute command when an item from the dropdown is selected.

        _this.listenTo(dropdownView, 'execute', function (evt) {
          editor.execute(evt.source.commandName, {
            value: evt.source.commandParam
          });
          editor.editing.view.focus();
        });

        return dropdownView;
      });
    }
    /**
     * Returns options as defined in `config.fontFamily.options` but processed to account for
     * editor localization, i.e. to display {@link module:font/fontfamily~FontFamilyOption}
     * in the correct language.
     *
     * Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
     * when the user configuration is defined because the editor does not exist yet.
     *
     * @private
     * @returns {Array.<module:font/fontfamily~FontFamilyOption>}.
     */

  }, {
    key: "_getLocalizedOptions",
    value: function _getLocalizedOptions() {
      var editor = this.editor;
      var t = editor.t;
      var options = normalizeOptions(editor.config.get(FONT_FAMILY).options);
      return options.map(function (option) {
        // The only title to localize is "Default" others are font names.
        if (option.title === 'Default') {
          option.title = t('Default');
        }

        return option;
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'FontFamilyUI';
    }
  }]);

  return FontFamilyUI;
}(Plugin); // Prepares FontFamily dropdown items.
// @private
// @param {Array.<module:font/fontsize~FontSizeOption>} options
// @param {module:font/fontsize/fontsizecommand~FontSizeCommand} command


export { FontFamilyUI as default };

function _prepareListOptions(options, command) {
  var itemDefinitions = new Collection(); // Create dropdown items.

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var option = _step.value;
      var def = {
        type: 'button',
        model: new Model({
          commandName: FONT_FAMILY,
          commandParam: option.model,
          label: option.title,
          withText: true
        })
      };
      def.model.bind('isOn').to(command, 'value', function (value) {
        // "Default" or check in strict font-family converters mode.
        if (value === option.model) {
          return true;
        }

        if (!value || !option.model) {
          return false;
        }

        return value.split(',')[0].replace(/'/g, '').toLowerCase() === option.model.toLowerCase();
      }); // Try to set a dropdown list item style.

      if (option.view && option.view.styles) {
        def.model.set('labelStyle', "font-family: ".concat(option.view.styles['font-family']));
      }

      itemDefinitions.add(def);
    };

    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return itemDefinitions;
}